/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classnames from 'classnames';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

interface IProps {
  value: any;
  selected: boolean;
  onClick: (value: any) => {};
  children?: any;
  [key: string]: any;
}

export const Option = React.forwardRef((props: IProps, ref: any) => {
  const { value, selected, onClick, children, ...rest } = props;
  const classes = useStyles();

  return (
    <MenuItem
      ref={ref}
      className={classnames(classes.root)}
      onClick={() => onClick(value)}
      selected={!!selected}
      {...rest}
    >
      {children}
    </MenuItem>
  );
});
